//
// Site JS
//

// Import CSS via Vite
import.meta.glob('/src/pcss/app.css', { eager: true });
import.meta.glob('/craft/components/**/*.css', { eager: true });

// Require all Twig component custom element scripts
import.meta.glob('/craft/components/**/elements.js', { eager: true });

// Check if JS is enabled in browser, if so the `no-js` class is removed from <body>
document.body.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', function () {

    // Remove .preload class
    document.body.classList.remove('preload');

}, false);

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR");
  });
}
